import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Organization} from '../../../../model/organization';
import {Tenant} from '../../../../model/tenant';

@Component({
  selector: 'app-synoptics-form-info',
  templateUrl: './synoptics-form-info.component.html',
  styleUrls: ['./synoptics-form-info.component.scss']
})
export class SynopticsFormInfoComponent {

  @Input() synopticInfoForm: FormGroup;
  @Input() mode: 'create' | 'edit';
  @Input() tenants: Tenant[];
  @Input() organizations: Organization[];
  @Output() tenantChange: EventEmitter<Tenant>;
  @Output() organizationChange: EventEmitter<Organization>;

  constructor() {
    this.tenantChange = new EventEmitter<Tenant>();
    this.organizationChange = new EventEmitter<Organization>();
  }

  public onOrganizationChange(event): void {
    this.organizationChange.emit(event.value);
  }

  public onTenantChange(event): void {
    this.tenantChange.emit(event.value);
  }

}
